import React from 'react';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import
{
    Box,
    Checkbox,
    Tooltip,
    IconButton,
    Typography,
    Badge,
    Chip,
} from '@mui/material';
import { EditOutlined } from '@mui/icons-material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { FULL_PERMISSION } from '../../../constants/Constant';
// import IOSSwitch from '../../../sharedcomponents/switchComponent/IOSSwitch';
// import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import moment from 'moment';
import Helper from '../../../utility/helper';
import ParticiapntList from '../../StaffSchedule/dataList/participantLists';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    columnContent: {
        display: 'flex',
        alignItems: 'center',
        // this logic needs to be handle for mobile view
        [theme.breakpoints.only('xs')]: {
            flexBasis: '33%',
        },
    },
    wrapTextStyle: {
        display: 'inline-block',
        whiteSpace: 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '40ch',
    },
    transportLogo: {
        height: 15,
        width: 20,
    },
    mailLogo: {
        height: 15,
        width: 20,
        marginRight: 5,
    },

    actionIcon: {
        width: 20,
    },
    setScale: {
        transform: 'scale(1)',
        fontSize: '01rem',
        stroke: '#fff',
        strokeWidth: 1,
        marginTop: '-1px',
        marginLeft: 0,
        color: 'primary',
    },
}));
export default function DataListRowItem(props)
{
    const classes = useStyles();
    const { row, items, item, index } = props;
    const userInfo = Helper.getStorage('userInfo');
    // console.log("props",row.label);
    //const [anchorEl, setAnchorEl] = React.useState(null);
    //const open = Boolean(anchorEl);
    // const onPopover = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };

    // const closePopover = () => {
    //     setAnchorEl(null);
    // };
    
    return (
        <Box
            key={index}
            className={classes.columnContent}
            sx={
                row.label === 'Action' || (row.alignRight != undefined && row.alignRight)
                    ? {
                        flex: `${row.width}`,
                        justifyContent: 'flex-end',
                    }
                    : !row.type && row.alignCenter != undefined
                        ? {
                            flex: `${row.width}`,
                            justifyContent: 'center',
                        }
                        : row.alignLeft != undefined
                            ? {
                                flex: `${row.width}`,
                                justifyContent: 'left',
                            }
                            : {
                                flex: `${row.width}`,
                                justifyContent: 'left',
                            }
            }>
            {row.label === 'checkbox' ?
                !props.hideCheckBox &&
                (
                    <Checkbox
                        inputProps={{
                            'aria-label': 'Participant',
                        }}
                        checked={item.selected ? item.selected : false}
                        onChange={(event) => props.onCheckSelect(event, item)}
                        // color="black"
                        value={row[row.key]}
                        disabled={
                            item.disableRow != undefined ? item.disableRow : false
                        }
                    />
                ) :
                // row.isPublished && props.modPermission && props.modPermission == FULL_PERMISSION ? (
                //     <Tooltip title="Published" aria-label="Published">
                //         <IconButton
                //             color="primary"

                //         >
                //             <CloudDoneOutlinedIcon
                //                 fontSize="small"
                //                 color={
                //                     item.disableRow != undefined
                //                         ? 'default'
                //                         : 'primary'
                //                 }
                //             />
                //         </IconButton>
                //     </Tooltip>
                // ) :
                row.label === 'Action' ? (
                    // !props.showUsersList && row[row.key] === 'isPublish' && props.modPermission && props.modPermission == FULL_PERMISSION ? (
                    //     <Tooltip title="Published" aria-label="Published">
                    //         <IconButton
                    //             color="primary"

                    //         >
                    //             <CloudDoneOutlinedIcon
                    //                 fontSize="small"
                    //                 color={
                    //                     item.disableRow != undefined
                    //                         ? 'default'
                    //                         : 'primary'
                    //                 }
                    //             />
                    //         </IconButton>
                    //     </Tooltip>
                    // ) :
                    !props.showUsersList &&
                        row[row.key] === 'showRowPublish' &&
                        props.modPermission &&
                        props.modPermission == FULL_PERMISSION ?
                        !props.hideCheckBox &&
                        (
                            item.actualData.isRowPublished ? (
                                <CheckCircleIcon
                                    fontSize="small"
                                    style={{ color: '#008000' }}
                                />
                            ) : (
                                <UnpublishedIcon
                                    fontSize="small"
                                    style={{ color: '#FF5733' }}
                                />
                            )
                        ) : // <Tooltip
                        //     title={'Publish'}
                        //     onClick={() => props.onRowToggleChange(item)}
                        //     >
                        //     <IconButton>
                        //         <IOSSwitch
                        //         dis
                        //             sx={{
                        //                 m: 1,
                        //             }}
                        //             checked={item.actualData.isRowPublished}
                        //         />
                        //     </IconButton>
                        // </Tooltip>
                        !props.showUsersList && props.showSubActivity &&
                            row[row.key] === 'Add SubActivity' &&
                            props.modPermission &&
                            props.modPermission == FULL_PERMISSION ?
                            !props.hideCheckBox &&
                            (
                                <Tooltip title="Add SubActivity" aria-label="add">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.handleAddSubActivity(item)}
                                        disabled={
                                            item.disableRow != undefined
                                                ? item.disableRow
                                                : false
                                        }>
                                        <LibraryAddOutlinedIcon
                                            fontSize="small"
                                            color={
                                                item.disableRow != undefined
                                                    ? 'default'
                                                    : 'primary'
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : !props.showUsersList &&
                                row[row.key] === 'Add Participants' &&
                                props.modPermission &&
                                props.modPermission == FULL_PERMISSION ?
                                !props.hideCheckBox &&
                                (
                                    <Tooltip title="Add Participants" aria-label="add">
                                        <IconButton
                                            color="primary"
                                            onClick={() => props.handleAddParticipants(item)}
                                            disabled={
                                                item.disableRow != undefined
                                                    ? item.disableRow
                                                    : false
                                            }>
                                            <GroupAddIcon
                                                fontSize="small"
                                                color={
                                                    item.disableRow != undefined
                                                        ? 'default'
                                                        : 'primary'
                                                }
                                            />
                                        </IconButton>
                                    </Tooltip>
                                ) : !props.showUsersList &&
                                    row[row.key] === 'Participants' &&
                                    props.modPermission &&
                                    props.modPermission == FULL_PERMISSION ?
                                    !props.hideCheckBox &&
                                    (
                                        <Tooltip title="View Participants" aria-label="view">
                                            <IconButton
                                                color="primary"
                                                onClick={() => props.handleViewParticipants(item)}
                                                disabled={
                                                    item.disableRow != undefined
                                                        ? item.disableRow
                                                        : false
                                                }>
                                                <Badge badgeContent={row.count} color="primary">
                                                    <PeopleAltIcon
                                                        fontSize="small"
                                                        color={
                                                            item.disableRow != undefined
                                                                ? 'default'
                                                                : 'primary'
                                                        }
                                                    />
                                                </Badge>
                                            </IconButton>
                                        </Tooltip>
                                    ) : row[row.key] == 'Edit'  && !props.showUsersList  && 
                                        props.modPermission &&
                                        props.modPermission == FULL_PERMISSION ? (
                                        <Tooltip title="Edit" aria-label="edit">
                                            <IconButton
                                                color="primary"
                                                onClick={() => (props.hideCheckBox && item.actualData.subActivities.length > 0) ? props.editSubActivityRow(items) : props.editRow(item)}
                                                disabled={
                                                    item.disableRow != undefined
                                                        ? item.disableRow
                                                        : false
                                                }>
                                                <EditOutlined
                                                    fontSize="small"
                                                    color={
                                                        item.disableRow != undefined
                                                            ? 'default'
                                                            : 'primary'
                                                    }
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    ) : row[row.key] == 'Delete'  && !props.showUsersList && props.hideCheckBox &&
                                        props.modPermission &&
                                        props.modPermission == FULL_PERMISSION ? (
                                        <Tooltip title="Delete" aria-label="delete">
                                            <IconButton
                                                color="primary"
                                                onClick={() => props.deleteSubActivityRow(items)}
                                                disabled={
                                                    item.disableRow != undefined
                                                        ? item.disableRow
                                                        : false
                                                }>
                                                <DeleteOutlineOutlinedIcon
                                                    fontSize="small"
                                                    color={
                                                        item.disableRow != undefined
                                                            ? 'default'
                                                            : 'primary'
                                                    }
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    ) : null
                ) : row.showChips !== undefined && !props.hideCheckBox ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection:
                                row.inColumn != undefined ? 'column' : 'row',
                            justifyContent:
                                row.alignCenter != undefined
                                    ? row.type
                                        ? 'left'
                                        : 'center'
                                    : 'left',
                            alignItems:
                                row.alignCenter != undefined ? 'center' : 'start',
                            flexWrap: 'wrap',
                        }}>
                        {row[row.key].length > 0
                            ? row[row.key].split(', ').map((chipItem) =>
                            {
                                return (
                                    chipItem !== '' && (
                                        <Chip
                                            key={chipItem}
                                            label={chipItem}
                                            sx={{
                                                mr: '4px',
                                                mb: '2px',
                                                '& .MuiChip-label': {
                                                    maxWidth: '30ch',
                                                },
                                            }}
                                        />
                                    )
                                );
                            })
                            : null}
                    </Box>
                ) : row.label == 'ScheduleParticipant' && !props.showUsersList && (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            alignItems: 'left',
                        }}>
                        {!props.hideCheckBox && item.actualData.participants && item.actualData.participants.length > 0 && item.actualData.userType === 'Participant' ?
                            <>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Participants
                                </Typography>

                                <Box
                                    sx={{
                                        display: 'inline',
                                        flexDirection: 'row',

                                    }}
                                    component="div" 
                                >   
                                    <ParticiapntList item={item} participant={true}  subActivitiy={false} endUser={false}/>  

                                    {/* {item.actualData.participants.map((vals, index) =>
                                    {
                                        if (vals.userType === 'Participant')
                                        {
                                            return (
                                                <Typography
                                                    fontSize={11}
                                                    key={vals.userID}
                                                    sx={{
                                                        wordBreak: 'break-word',
                                                    }}>
                                                    {vals.participant.replace(',', ' ') + (item.actualData.participants.length !== (index + 1) ? ', ' : '')}
                                                </Typography>
                                            )
                                        }

                                    })
                                    } */}
                                </Box>
                            </>
                            :
                            <>
                                {(props.hideCheckBox && items !== undefined) &&
                                    items.subActivityParticipants.length > 0 ?
                                    <> <Typography
                                        variant="h4"
                                        flexGrow={1}
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Participants
                                    </Typography>

                                        <Box
                                            sx={{
                                                display: 'inline',
                                                flexDirection: 'row',
                                            }}
                                        >
                                            <ParticiapntList item={items} participant={true}  subActivitiy={true} endUser={false}/>  
                                            {/* {items.subActivityParticipants.map((vals, index) =>
                                            {
                                                if (vals.userType === 'Participant')
                                                {
                                                    return (
                                                        <Typography
                                                            fontSize={11}
                                                            key={vals.userID}
                                                            sx={{
                                                                wordBreak: 'break-word',
                                                            }}>
                                                            {vals.participant.replace(',', ' ') + (items.subActivityParticipants.length !== (index + 1) ? ', ' : '')}
                                                        </Typography>
                                                    )
                                                }
                                            })
                                            } */}
                                        </Box>
                                    </>
                                    :
                                    null
                                }
                            </>
                        }
                    </Box>
                ) : row.label == 'ScheduleParticipant' && !(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) && Helper.isEventStaff(userInfo) ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            alignItems: 'left',
                        }}>
                        {!props.hideCheckBox && item.actualData.isStaffing ?
                            <>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Staffing
                                </Typography>
                                <Typography
                                    fontSize={11}
                                    sx={{
                                        wordBreak: 'break-word',
                                    }}>
                                    All
                                </Typography>
                            </>
                            :
                            !props.hideCheckBox && item.actualData.participants && item.actualData.participants.length > 0 ?
                                <>
                                    <Typography
                                        variant="h4"
                                        flexGrow={1}
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Staffing
                                    </Typography>

                                    <Box
                                        sx={{
                                            display: 'inline',
                                            flexDirection: 'row',
                                        }}
                                    >
                                        <ParticiapntList item={item}  subActivitiy={false} endUser={true}/>  
                                        {/* {item.actualData.participants.map((vals, index) =>
                                        {                                            
                                            if (vals.userType === 'Event Staff' && (vals.roleName === 'Event Staff' || vals.roleName === "Event Admin"))
                                            {
                                                return (
                                                    <Typography
                                                        fontSize={11}
                                                        key={vals.userID}
                                                        sx={{
                                                            wordBreak: 'break-word',
                                                            fontWeight: userInfo.userID === vals.userID ? '900' : null
                                                        }}>
                                                        {vals.participant.replace(',', ' ') + (item.actualData.participants.length !== (index + 1) ? ', ' : '')}
                                                    </Typography>
                                                )
                                            }

                                        })
                                        } */}
                                    </Box>
                                </>
                                :
                                <>
                                    {(props.hideCheckBox && items !== undefined) ?
                                        items.isStaffing ?
                                            <>
                                                <Typography
                                                    variant="h4"
                                                    flexGrow={1}
                                                    fontSize={12}
                                                    fontWeight={500}
                                                    color="primary">
                                                    Staffing
                                                </Typography>
                                                <Typography
                                                    fontSize={11}
                                                    sx={{
                                                        wordBreak: 'break-word',
                                                    }}>
                                                    All
                                                </Typography>
                                            </>
                                            :
                                            <>
                                                {items.subActivityParticipants.length > 0 ?
                                                    <> <Typography
                                                        variant="h4"
                                                        flexGrow={1}
                                                        fontSize={12}
                                                        fontWeight={500}
                                                        color="primary">
                                                        Staffing
                                                    </Typography>

                                                        <Box
                                                            sx={{
                                                                display: 'inline',
                                                                flexDirection: 'row',
                                                            }}
                                                        >
                                                            <ParticiapntList item={items}  subActivitiy={true} endUser={true}/>  
                                                            {/* {items.subActivityParticipants.map((vals) =>
                                                            {
                                                                if (vals.userType === 'Event Staff')
                                                                {
                                                                    return (
                                                                        <Typography
                                                                            fontSize={11}
                                                                            key={vals.userID}
                                                                            sx={{
                                                                                wordBreak: 'break-word',
                                                                                fontWeight: userInfo.userID === vals.userID ? '900' : null
                                                                            }}>
                                                                            {vals.participant.replace(',', ', ') + ' '}
                                                                        </Typography>
                                                                    )
                                                                }
                                                            })
                                                            } */}
                                                        </Box>
                                                    </>
                                                    :
                                                    null
                                                }
                                            </>
                                        :
                                        null
                                    }
                                </>
                        }
                    </Box>
                ) : row[row.key] && row[row.key].length >= 0 ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection:
                                row.inColumn != undefined ? 'column' : 'row',
                            justifyContent:
                                row.alignCenter != undefined
                                    ? row.type
                                        ? 'left'
                                        : 'center'
                                    : 'left',
                            alignItems:
                                row.alignCenter != undefined ? 'center' : 'start',
                            ml: props.hideCheckBox ? 1 : 0
                        }}>
                        {row.showLabel == undefined ? (
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                {(props.hideCheckBox && item.actualData.subActivities.length > 0) ? row.key == 'attire' ? null :  row.key == 'location' ? null : row.label : row.label}
                            </Typography>
                        ) : null}

                       <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            // color={row.key == 'activityName' ? 'secondary' : null}
                            fontWeight={row.key == 'activityName' ? 600 : 400}>
                            {row[row.key] ? (
                                    <span className={classes.wrapTextStyle}>
                                        {(props.hideCheckBox && item.actualData.subActivities.length > 0) ?
                                            row.key == 'activityName'   
                                                ? items.subActivityName
                                                : row.key == "startTime"
                                                    ? (items.startDateTime != null ? (moment(items.startDateTime).format('hh:mm:ss') === '12:00:00') ? '' : moment(items.startDateTime).format('hh:mm A') : '')
                                                    : row.key == "endTime"
                                                        ? (items.endDateTime != null ? (moment(items.endDateTime).format('hh:mm:ss') === '12:00:00') ? '' : moment(items.endDateTime).format('hh:mm A') : '')
                                                        : row.key == "location"
                                                            ? null
                                                            : row.key == "attire" ? null : null
                                            : row.key == "startTime"
                                                ? item.actualData.startDateTime !== null
                                                    ? item.actualData.startTime !== null ? moment(item.actualData.startTime, 'HH:mm:ss').format('hh:mm A') : ''  : ''
                                                : row.key == "endTime"
                                                    ? item.actualData.endDateTime !== null
                                                        ? item.actualData.endTime !== null ? moment(item.actualData.endTime, 'HH:mm:ss').format('hh:mm A') : '' : ''
                                                        : row.key == "ttire"
                                                        ? item.actualData.attire !== null
                                                            ? item.actualData.attire !== null ? item.actualData.attire : '' : '' : row[row.key]}
                                    </span>
                            ) : (
                                ''
                            )}
                        </Typography>
                        {row.showNote && row.notes != '' && !props.hideCheckBox ? (
                            <Typography
                                fontSize={11}
                                sx={{
                                    wordBreak: 'break-word',
                                    fontWeight: 'bold'
                                }}>
                                Notes: {props.hideCheckBox ? items.notes : row.notes}
                            </Typography>
                        ) : null}
                        {row.showNote && props.hideCheckBox && items !== undefined && items.notes !== null ? (
                            <Typography
                                fontSize={11}
                                sx={{
                                    wordBreak: 'break-word',
                                    fontWeight: 'bold'
                                }}>
                                Notes: {items.notes}
                            </Typography>
                        ) : null}
                    </Box>
                ) : null
            }
        </Box >
    );
}
